import { postApi } from '../api/digitalVault';
import { chunkArray, groupByRepository } from '../utils';
const deleteUserFiles = async (params, logger) => {
    const { files, ignoreMissing, purge, batchSize } = params;
    const filesToDelete = files?.filter((file) => file?.uri?.includes('file://'));
    const foldersToDelete = files?.filter((folder) => folder?.uri?.includes('folder://') || folder?.originData?.uri?.includes('folder://'));
    const groupFiles = groupByRepository(filesToDelete);
    const groupFolders = groupByRepository(foldersToDelete);
    const request = [];
    groupFiles.forEach(({ files, repository }) => {
        const chunkedGroup = chunkArray(files, batchSize);
        chunkedGroup.forEach((array) => {
            const query = new URLSearchParams();
            array.forEach((value) => query.append('path', value?.toString()));
            purge && query.set('purge', 'true');
            ignoreMissing && query.set('ignoreMissing', 'true');
            request.push({ query, repository, type: 'file' });
        });
    });
    groupFolders.forEach(({ files, repository }) => {
        const chunkedGroup = chunkArray(files, batchSize);
        chunkedGroup.forEach((array) => {
            const query = new URLSearchParams();
            array.forEach((value) => query.append('path', value?.toString()));
            purge && query.set('purge', 'true');
            ignoreMissing && query.set('ignoreMissing', 'true');
            request.push({ query, repository, type: 'folder' });
        });
    });
    return Promise.all(request.map(async ({ query, repository, type }) => {
        type &&
            (await postApi(query, `repository/${repository || 'default'}/${type}`, {
                'X-HTTP-Method-Override': 'DELETE',
            }, logger));
    }));
};
export default deleteUserFiles;
